import { IconProps } from '../types'

export default function IconInactiveVibrationOn({
    width = '24',
    height = '24',
    className,
}: IconProps) {

    return (
        <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <g clip-path='url(#clip0_6680_15110)'>
                <g filter='url(#filter0_g_6680_15110)'>
                    <path d='M8.8125 19.1719C8.37422 19.1719 7.99902 19.0158 7.68691 18.7037C7.3748 18.3916 7.21875 18.0164 7.21875 17.5781V6.42187C7.21875 5.98359 7.3748 5.6084 7.68691 5.29629C7.99902 4.98418 8.37422 4.82812 8.8125 4.82812H15.1875C15.6258 4.82812 16.001 4.98418 16.3131 5.29629C16.6252 5.6084 16.7812 5.98359 16.7812 6.42187V17.5781C16.7812 18.0164 16.6252 18.3916 16.3131 18.7037C16.001 19.0158 15.6258 19.1719 15.1875 19.1719H8.8125ZM12.5678 8.5834C12.7205 8.43066 12.7969 8.24141 12.7969 8.01562C12.7969 7.78984 12.7205 7.60059 12.5678 7.44785C12.415 7.29512 12.2258 7.21875 12 7.21875C11.7742 7.21875 11.585 7.29512 11.4322 7.44785C11.2795 7.60059 11.2031 7.78984 11.2031 8.01562C11.2031 8.24141 11.2795 8.43066 11.4322 8.5834C11.585 8.73613 11.7742 8.8125 12 8.8125C12.2258 8.8125 12.415 8.73613 12.5678 8.5834ZM2.4375 14.3906V9.60937H4.03125V14.3906H2.4375ZM4.82812 15.9844V8.01562H6.42187V15.9844H4.82812ZM19.9687 14.3906V9.60937H21.5625V14.3906H19.9687ZM17.5781 15.9844V8.01562H19.1719V15.9844H17.5781Z' fill='#5486AC' />
                </g>
            </g>
            <defs>
                <filter id='filter0_g_6680_15110' x='2.0625' y='4.45312' width='19.875' height='15.0938' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
                    <feTurbulence type='fractalNoise' baseFrequency='0.1111111119389534 0.1111111119389534' numOctaves='3' seed='6155' />
                    <feDisplacementMap in='shape' scale='0.75' xChannelSelector='R' yChannelSelector='G' result='displacedImage' width='100%' height='100%' />
                    <feMerge result='effect1_texture_6680_15110'>
                        <feMergeNode in='displacedImage' />
                    </feMerge>
                </filter>
                <clipPath id='clip0_6680_15110'>
                    <rect width='19.125' height='19.125' fill='white' transform='translate(2.4375 2.4375)' />
                </clipPath>
            </defs>
        </svg>
    )
}